import { render, staticRenderFns } from "./RiskAssessmentStep.vue?vue&type=template&id=f5aec17e"
import script from "./RiskAssessmentStep.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports